import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import './AddProjectForm.css'; // Optional: create this for custom styling

const AddProjectForm = () => {
  const [name, setName] = useState('');
  const [svgFilename, setSvgFilename] = useState('');
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!name.trim()) {
      setError('Project name is required');
      setMessage(null);
      return;
    }

    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/projects`, {
        name,
        svg_filename: svgFilename || null
      });

      if (response.data.success) {
        setMessage('Project added successfully');
        setError(null);
        setName('');
        setSvgFilename('');
        navigate('/add-plots');

      }else {
        setMessage('Something went wrong');
      }
    } catch (err) {
      console.error('Add project error:', err);
      setError(err.response?.data?.message || 'Something went wrong');
      setMessage('Failed to add project');
    }
  };

  return (
    <div className="add-project-container">
      <h2>Add New Project</h2>
      <form onSubmit={handleSubmit} className="add-project-form">
        <label>
          Project Name:
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="e.g. Baraka Estate"
          />
        </label>

        <label>
          Initial SVG Filename (optional):
          <input
            type="text"
            value={svgFilename}
            onChange={(e) => setSvgFilename(e.target.value)}
            placeholder="e.g. baraka.svg"
          />
        </label>

        <button type="submit">Add Project</button>

        {message && <p className="success">{message}</p>}
        {error && <p className="error">{error}</p>}
      </form>
    </div>
  );
};

export default AddProjectForm;
